export const LOGIN = {
  LOGO: 'loginLogo',
  USERNAME_INPUT: 'usernameInput',
  PASSWORD_INPUT: 'passwordInput',
  SUBMIT_BUTTON: 'submitButton'
} as const;
